// import {getWindowWidth} from "../../helpers/getWindowSize";
// import getSliderOffset from "../../helpers/getSliderOffset";

const swiperNewsCards = {
    swiperInstance: null,
    init: () => {
        const mediaMatch = window.matchMedia('(min-width: 1023px)');
        mediaMatch.addListener(swiperNewsCards.breakpointCheck);
        swiperNewsCards.breakpointCheck(mediaMatch);
    },

    breakpointCheck: (mediaMatch) => {
        // if larger viewport and multi-row layout needed
        if (mediaMatch.matches === true) {
            // clean up old instances and inline styles when available
            if ( swiperNewsCards.swiperInstance !== null ) swiperNewsCards.swiperInstance.destroy( true, true );
            // else if a small viewport and single column layout needed
        } else if (mediaMatch.matches === false) {
            // fire small viewport version of swiper
            return swiperNewsCards.enableSwiper();
        }
    },

    enableSwiper: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-news-cards');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperNewsCards.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {
    // const windowWidth = getWindowWidth();
    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 32,
        slidesPerView: 1,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar',
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            }
        }
    }
}

export default swiperNewsCards;